import ReactSelect, { Props } from 'react-select'

import { FormError } from 'shared/atoms'
import { Label } from 'shared/atoms'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'
import { forwardRef, Ref } from 'react'
import { selectClassNames, SelectVariant } from './classNames'

type SelectProps = WithClassName<
	{
		id: string
		label?: string
		error?: {
			message: string
		}
		required?: boolean
		variant?: SelectVariant
		handleInfiniteScroll?: () => void
		onChange: (e: any) => void
	} & Props
>

export const Select = forwardRef(
	(
		{
			label,
			options = [],
			isDisabled = false,
			isSearchable = false,
			error,
			className,
			placeholder = '',
			isLoading = false,
			isMulti = false,
			required = false,
			isClearable = true,
			variant = 'default',
			handleInfiniteScroll,
			onChange,
			...rest
		}: SelectProps,
		_ref: Ref<HTMLInputElement>
	) => {
		const onMenuScrollToBottom = () => {
			handleInfiniteScroll?.()
		}

		return (
			<div
				className={cn(
					'flex cursor-pointer flex-col text-xs [-webkit-tap-highlight-color:transparent]',
					variant === 'default' ? 'min-w-[130px] gap-y-2.5' : 'min-w-0 gap-y-1.5',
					isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
					className
				)}>
				<Label disabled={variant === 'default' && isDisabled} required={required} text={label} />
				<ReactSelect
					options={options}
					isSearchable={isSearchable}
					isClearable={isClearable}
					components={{ IndicatorSeparator: () => null }}
					isLoading={isLoading}
					onMenuScrollToBottom={onMenuScrollToBottom}
					captureMenuScroll={true}
					isMulti={isMulti}
					placeholder={placeholder}
					isDisabled={isDisabled}
					onChange={onChange}
					classNames={selectClassNames[variant]}
					{...rest}
				/>
				<FormError text={error?.message} />
			</div>
		)
	}
)
